import { useState , useEffect} from 'react';
import ProcessList from './ProcessList';
import RAMUsage from './RAMUsage';
import SqlServer from './SqlServer';
import RemoteAccess from './RemoteAccess';


export interface InputProps {
    url: any
  }
const MiscellaneousFunctions = ({url}:InputProps) =>{
    const [activeTab, setActiveTab] = useState(1);
   
  const handleTabClick = (id:any) => {
    setActiveTab(id);
  };
  useEffect(() => {
  }, [])
  return (
    <div>
        <ul className="inner-tabs" style={{justifyContent:'center'}}>
            <li className={activeTab === 1 ? 'financialRepTabActive' : 'financialRepTab'} onClick={() => handleTabClick(1) }> لیست فرآیندها </li>
            <li className={activeTab === 2 ? 'statisticalRepTabActive' : 'statisticalRepTab'} onClick={() => handleTabClick(2) }>حافظه </li>
            <li className={activeTab === 3 ? 'digitalSignatureTabActive' : 'digitalSignatureTab'} onClick={() => handleTabClick(3) }>Sql Server </li>
            <li className={activeTab === 4 ? 'systemInfoTabActive' : 'systemInfoTab'} onClick={() => handleTabClick(4) }>RemoteAccess</li>
        </ul>

        <div className="inner-tabs_content">
            { 
              activeTab === 1 && <div className="tab_panel">
                <ProcessList url={url} />
              </div> 
            }
            { activeTab === 2 && <div className="tab_panel"><RAMUsage url={url}/> </div> }
            { activeTab === 3 && <div className="tab_panel"> <SqlServer url={url} /> </div> }
            { activeTab === 4 && <div className="tab_panel"> <RemoteAccess url={url} /></div> }
        </div>
    </div>
  );
};

export default MiscellaneousFunctions;